import React from "react";
import {  CheckCircle, XCircle } from "lucide-react";

const BeforeAfterCard = ({ title, before, after }) => {
  return (
    <div className="card before-after-card">
      <h3 className="card-title">{title}</h3>

      <div className="comparison-container">
        <div className="comparison-side before">
          <h4 className="side-label">BEFORE</h4>
          <ul className="point-list">
            {before.map((item, index) => (
              <li key={`before-${index}`} className="point-item">
                <XCircle className="point-icon negative" />
                <span className="point-text" style={{ color: 'black' }}>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="divider"></div>

        <div className="comparison-side after">
          <h4 className="side-label">AFTER</h4>
          <ul className="point-list">
            {after.map((item, index) => (
              <li key={`after-${index}`} className="point-item">
                <CheckCircle className="point-icon positive" />
                <span className="point-text" style={{ color: 'black' }}>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

const AlgoHeadsBenefits = () => {
  const benefitCards = [
    {
      title: "Save Time in Your Job Search",
      before: [
        "Spending hours cross-checking LinkedIn and job boards",
        "Manually tracking applications in spreadsheets",
        "Switching between multiple platforms",
      ],
      after: [
        "One dashboard for all referral opportunities",
        "Automated connection matching with open positions",
        "Integrated job search in a single platform",
      ],
    },
    {
      title: "Secure Quality Referrals",
      before: [
        "Cold messaging distant connections with no response",
        "Unclear who to ask for referrals",
        "Manually tracking referral requests",
      ],
      after: [
        "Target the right connections with relevant context",
        "Know exactly who can refer you at each company",
        "Easily track and manage all referrals",
      ],
    },
    {
      title: "Find Hidden Job Opportunities",
      before: [
        "Missing job postings as they get buried in 24-48 hours",
        "No visibility into your network's opportunities",
        "Manually searching without real-time updates",
      ],
      after: [
        "Instant alerts for the newest jobs in your network",
        "See where you already have insider connections",
        "Apply early with confidence before positions close",
      ],
    },
  ];

  return (
    <div className="benefits-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title" style={{ color: 'white' }}>
            Here's what you can get done with AlgoHeads
          </h2>
          <p className="section-subtitle" style={{ color: 'white' }}>Stop searching. Start connecting.</p>
        </div>

        <div className="benefits-grid">
          {benefitCards.map((card, index) => (
            <BeforeAfterCard
              key={index}
              title={card.title}
              before={card.before}
              after={card.after}
            />
          ))}
        </div>

        
      </div>
    </div>
  );
};

export default AlgoHeadsBenefits;
